<template>
    <b-row>
        <b-table :fields="fields" :items="participantes" :busy="tableBusy" :current-page="currentPage" hover
            no-border-collapse sort-by="" :sort-desc="true" stacked="sm" responsive show-empty foot-variant="light">
            <template #empty>
                <span>Não foram encontrados dados.</span>
            </template>
            <template #emptyfiltered>
                <span>Não foram encontrados dados.</span>
            </template>
            <template #table-busy>
                <div class="text-center text-dark">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong class="loading-text">Carregando...</strong>
                </div>
            </template>
            <template v-if="participantes.length > 0" #custom-foot>
              <b-tr>
                <b-th></b-th>
                <b-th></b-th>
                <b-th>Valor total do Contrato / Ordem de Fornecimento</b-th>
                <b-th>{{vlTotal !== null ? formatMoeda(vlTotal) : "-"}}</b-th>
              </b-tr>
            </template>
        </b-table>
        <table-pagination v-if="totalRows > pageSize" :total-rows=totalRows :per-page=pageSize @pageChange="pageChange" />
    </b-row>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { UtilsTS } from '@/utilsts'


import contratoService from '@/services/licitacoes/contratoService'
import { fieldsParticipanteContrato } from '@/types/licitacoes/contratos/fields-participante-contrato'
import { ParticipanteContrato } from '@/types/licitacoes/contratos/participante-contrato'

import TablePagination from "@/components/atos-pessoal/TablePagination.vue";

import { TableField } from '@/types/table-field'


const CompProps = Vue.extend({
    name: 'DetalhesParticipantes',
    components: { TablePagination },
    props: {
        contrato: {
            type: Object,
            required: true
        }
    }
})

@Component
export default class DetalhesParticipantes extends mixins(UtilsTS, CompProps) {
    fields: TableField[] = fieldsParticipanteContrato
    participantes: ParticipanteContrato[] = []
    vlTotal: number | null

    //table-related
    currentPage = 1
    pageSize = 10
    totalRows = 0
    tableBusy = false

    async mounted() {
        this.loadData()
    }

    async loadData() {
        try {
            this.tableBusy = true
            const response = await contratoService.buscarParticipantes(this.contrato.IdContrato, this.currentPage, this.pageSize)
            if (response) {
                this.participantes = response.participantes.map(l => {
                    const participante = Object.assign(new ParticipanteContrato(), l)
                    return participante
                })
                this.vlTotal = response.vlTotal
                this.totalRows = response.totalRows
            } else {
                this.$toast.error('Erro ao consultar os participantes do contrato / OF.');
            }
        } finally {
            this.tableBusy = false;
        }
    }

    async pageChange(value) {
        this.currentPage = value;
        await this.loadData();
    }
}
</script>

<style></style>

<style scoped>
div.row>div>span:first-child {
    font-weight: bolder;
    display: block;
}
</style>